(function () {
  'use strict';
  var indicator = document.getElementById('MochiPageLoading');
  if (!indicator) return;
  var pill = indicator.querySelector('[data-mochi-loading-pill]');
  var pillTimer;
  var hideTimer;
  function hide() {
    clearTimeout(pillTimer);
    clearTimeout(hideTimer);
    indicator.hidden = true;
    pill.hidden = true;
    pill.textContent = '';
  }
  function show() {
    hide();
    indicator.hidden = false;
    pillTimer = setTimeout(function () { pill.hidden = false; pill.textContent = 'Loading…'; }, 200);
    hideTimer = setTimeout(hide, 15000);
  }
  document.addEventListener('click', function (event) {
    if (event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    var link = event.target.closest && event.target.closest('a[href]');
    if (!link || link.hasAttribute('target') || link.hasAttribute('download') || link.getAttribute('aria-disabled') === 'true') return;
    var href = link.getAttribute('href').trim();
    if (!href || href.charAt(0) === '#') return;
    var url;
    try { url = new URL(link.href, window.location.href); } catch (error) { return; }
    if (!/^https?:$/.test(url.protocol) || url.origin !== window.location.origin) return;
    if (url.pathname === location.pathname && url.search === location.search && url.hash) return;
    // Wait until all click handlers have had a chance to cancel an in-page action.
    queueMicrotask(function () { if (!event.defaultPrevented) show(); });
  });
  window.addEventListener('pageshow', hide);
  window.addEventListener('pagehide', hide);
})();
